import { Component, Mixins, Prop } from 'vue-property-decorator';
import { SecondStepModel } from '@/modules/DerSignUpModule/SecondStep/SecondStep.types';
import StoreModuleMixin from '@/mixins/StoreModuleMixin';
import { DerSignUpModuleState } from '@/modules/DerSignUpModule/DerSignUpModule.store';

@Component({
  components: {
    TitleTextHeaderModule: () => import('@/modules/TitleTextHeaderModule/TitleTextHeaderModule.vue'),
    RelatedItemsModule: () => import('@/modules/RelatedItemsModule/RelatedItemsModule.vue'),
  }
})
export default class DerSignUpThankYouMessage extends Mixins(StoreModuleMixin) {
  state!: DerSignUpModuleState;

  @Prop()
  model!: SecondStepModel;

  get shipIntro() {
    return this.state.ShipIntro;
  }

  get pastDers() {
    if (Object.keys(this.state.PastDers).length) {
      return this.state.PastDers
    }
    return false;
  }

  get userName() {
    return this.model.Person.FirstName;
  }

  get userEmail() {
    return this.model.Email;
  }

  get userEmailList() {
    let recipientsText = '';
    const recipientsList = this.model.Recipients;
    const { length: hasRecipients } = recipientsList;
    if (hasRecipients) {
      recipientsList.forEach((recipient, index) => {
        recipientsText += `${index === 0 && this.userEmail ? ', ' : ''} ${recipient.Email}${
          index !== hasRecipients - 1 ? ', ' : ''
        }`;
      });
    }

    return recipientsText;
  }

  get iterniraryText() {
    return (
      this.state.Itinararies.filter((itinarary) => itinarary.Value === this.model.ItineraryId).map(
        (itinarary) => itinarary.Text,
      )[0] || ''
    );
  }

  get itineraryLink() {
   return this.state.ItineraryLink
  }

  get shipNameAndDepartureDate() {
    return (
      this.state.Dates.filter((date) => date.Value === this.model.DepartureId).map(
        (date) => date.Text,
      )[0] || ''
    );
  }

  get shipName() {
    return this.shipNameAndDepartureDate ? this.shipNameAndDepartureDate.split('•')[1] : '';
  }

  get departureDate() {
    return this.shipNameAndDepartureDate ? this.shipNameAndDepartureDate.split('•')[0] : '';
  }
}
